import { useState } from "react";

import { useEventTracker } from "hooks/useEventTracker";
import { useSplitToggle } from "hooks/useSplit";
import { Action } from "utils/trackEvent";

import DispensaryCard, {
  DispensaryCardProps,
} from "components/botanic/DispensaryCard/DispensaryCard";
import PickupReadinessLabel from "components/botanic/DispensaryCard/PickupReadinessLabel";
import TrackImpression from "components/TrackImpression";

export const PickupReadinessDispensaryCard: React.FC<DispensaryCardProps> = ({
  dispensaryId,
  onClick,
  ctaOnClick,
  ...otherProps
}) => {
  const showPickupReadinessLabel = useSplitToggle("pickupReadinessTime_toggle");
  const { publishEvent } = useEventTracker();

  const [shownLabel, setShownLabel] = useState<boolean>(false);

  return (
    <TrackImpression
      category="retailer card rfp test"
      className="h-full"
      label="rfp test"
      customDimensions={{
        dispensaryId,
        experimentEnabled: showPickupReadinessLabel,
      }}
    >
      <DispensaryCard
        dispensaryId={dispensaryId}
        renderReadinessLabel={
          showPickupReadinessLabel
            ? () => (
                <PickupReadinessLabel
                  dispensaryId={dispensaryId}
                  setShownLabel={setShownLabel}
                />
              )
            : undefined
        }
        {...otherProps}
        onClick={(e) => {
          publishEvent({
            action: Action.click,
            category: "retailer card rfp test",
            dispensaryId,
            experimentEnabled: showPickupReadinessLabel,
            label: "rfp test",
            shownLabel,
          });
          onClick && onClick(e);
        }}
        ctaOnClick={(e) => {
          publishEvent({
            action: Action.click,
            category: "retailer card rfp test",
            dispensaryId,
            experimentEnabled: showPickupReadinessLabel,
            label: "rfp test cta",
            shownLabel,
          });
          ctaOnClick && ctaOnClick(e);
        }}
      />
    </TrackImpression>
  );
};

export default PickupReadinessDispensaryCard;
